import { styled } from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
import { SIDEBAR_WIDTH } from '../utils/constants';
export const StyledGuideLayout = styled.div `
  display: flex;
`;
export const StyledGuideContent = styled.div `
  width: 100%;
  height: calc(100vh - ${props => props.$desktopHeaderHeight ?? 0}px);
  overflow-y: auto;
  padding-inline-end: ${props => (props.$isSidebarMode ? SkapaTokens.space150 : 0)};

  @media (min-width: ${SkapaTokens.breakpointXl}) {
    width: calc(100% - ${SIDEBAR_WIDTH}px);
  }
`;
//# sourceMappingURL=styles.js.map